import { createContext, useContext, useState } from "react";

const defaultInputs = {
  sector: "Services / Conseil",
  maturity: "partiel",
  governance: "centralisee",  // centralisee / hybride / decentralisee
  nb_users: 1000,
  nb_contractors: 100,
  nb_seasonal: 0,
  seasonal_duration_months: 4,
  nb_b2b: 0,
  nb_nhi: null,
  nb_priv: null,
  nb_apps: 80,
  nb_apps_critical: null,
  nb_apps_saas_pct: 0.6,
  turnover_pct: 0.10,
  turnover_contractor_pct: 0.40,
  mover_pct: 0.15,
  incidents_last_3y: 0,
  hourly_user_custom: null,   // null = défaut secteur
  use_custom_hourly: false,
  // Existing tool branch
  has_existing_iam_tool: false,
  existing_tool_status: "scripts",
  // Advanced compliance defaults
  delay_access_d1_days: 3.0,
  days_to_revoke_leaver: 14,
  nb_review_campaigns_yr: 2,
  audit_hours_yr: 200,
};

const CalcCtx = createContext(null);

export const CalcProvider = ({ children }) => {
  const [inputs, setInputs] = useState(defaultInputs);
  const [results, setResults] = useState(null);
  const [lead, setLead] = useState({
    firstname: "",
    lastname: "",
    email: "",
    company: "",
    sector: "Services / Conseil",
  });

  // Reset uniquement les inputs + résultats, conserve le lead pour relancer une simulation
  const resetSimulation = () => {
    setInputs(defaultInputs);
    setResults(null);
  };

  return (
    <CalcCtx.Provider value={{ inputs, setInputs, results, setResults, lead, setLead, resetSimulation }}>
      {children}
    </CalcCtx.Provider>
  );
};

export const useCalc = () => {
  const ctx = useContext(CalcCtx);
  if (!ctx) throw new Error("useCalc must be inside CalcProvider");
  return ctx;
};
